import React from 'react';
import ReactDOM from 'react-dom/client'; // Use react-dom/client for React 18+
import './styles/index.css';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import Modal from "react-modal";
import "@amzn/meridian-tokens/base/font/amazon-ember.css"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// required by Modal to take the focus so screen reader does not read the other elements
Modal.setAppElement('#root');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();